import type { SendWhatsAppDTO } from '../types';

export interface WhatsAppPayload {
    to: string;
    from: string;
    body?: string;
    by?: { name: string; id: string };
    area?: string;
    storeId?: string;
    channel?: string;
    lead?: string;
    MediaUrl0?: string;
    MediaContentType0?: string;
    api?: string;
    templateType?: string;
    messageWithoutFormat?: string;
    options?: Record<string, string>;
    templateTitle?: string;
    contentSid?: string;
    contentTemplateBuilder?: unknown;
    language?: string;
    title?: string;
    isAssistantGenerated?: boolean;
    [key: string]: unknown;
}

/** Payload without api (each strategy adds its own) */
export type WhatsAppBasePayload = Omit<WhatsAppPayload, 'api'>;

/**
 * Builds the common payload from DTO (without api; each strategy adds its own).
 */
export function buildBasePayload(dto: SendWhatsAppDTO): WhatsAppBasePayload {
    const payload: WhatsAppBasePayload = {
        to: dto.to,
        from: dto.from,
        body: dto.message,
    };

    if (dto.sender) payload.by = dto.sender;
    if (dto.area) payload.area = dto.area;
    if (dto.storeId) payload.storeId = dto.storeId;
    if (dto.channel) payload.channel = dto.channel;
    if (dto.leadId) payload.lead = dto.leadId;
    if (dto.isAssistantGenerated)
        payload.isAssistantGenerated = dto.isAssistantGenerated;
    if (dto.mediaUrl) payload.MediaUrl0 = dto.mediaUrl;
    if (dto.mediaContentType) payload.MediaContentType0 = dto.mediaContentType;
    if (dto.attachments?.length) payload.MediaUrl0 = dto.attachments[0];

    if (dto.templatePayload) {
        payload._id = dto.templatePayload._id;
        payload.templateType = dto.templatePayload.templateType;
        payload.messageWithoutFormat = dto.templatePayload.messageWithoutFormat;
        payload.options = dto.templatePayload.options;
        payload.templateTitle = dto.templatePayload.templateTitle;
        payload.contentSid = dto.templatePayload.contentSid;
        payload.contentTemplateBuilder = dto.templatePayload.contentTemplateBuilder;
        payload.language = dto.templatePayload.language;
        payload.title = dto.templatePayload.title;
    }

    return payload;
}
